export default "__VITE_ASSET__76771d85__"